import { Box, Flex, Text } from "@chakra-ui/react";

interface Props {
  isSelected?: boolean;
  title: string;
  onClick: () => void;
}

export const NavTab: React.FC<Props> = ({
  isSelected = false,
  title,
  onClick,
}) => {
  return (
    <Flex
      borderLeftRadius="8px"
      transition="0.2s"
      _hover={{
        cursor: "pointer",
        bgColor: "primary.50",
      }}
      bgColor={isSelected ? "primary.50" : "transparent"}
      onClick={onClick}
    >
      <Box p={2} flexGrow={1}>
        <Text lineClamp={1}>{title}</Text>
      </Box>
      {isSelected && <Box width="4px" bgColor="primary.500" />}
    </Flex>
  );
};
